import React, { Component } from "react";
import { Form, Row, Col,FormGroup,Input,Label } from "reactstrap";
import FormComponent from "../../../../common/FormComponent";

import {
  Validator,
  submitValidator,
  refresh,
  errors,
  valid,
} from "../../../../common/Validator";
import DateFns from "date-fns";
import Notifier from "../../../aside/Notifier";
import ErrorNotifier from "../../../aside/ErrorNotifier";
import axios from "axios";
import { API_CANDIDATE,RS_API } from "../../../../utils/config";
import Button from "@material-ui/core/Button";
import moment from "moment";
import {withRouter} from 'react-router-dom'
import { getProfileInfo} from "../../../../redux/action/profileInfoAction"

import { connect } from "react-redux";
// import { GradientTwoTone, KeyboardReturnTwoTone } from "@material-ui/icons";

/**
 * UpdateCertificate Component for updating the certificate details.
 */
class UpdateCertificateDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      specilization: this.props.updateDataProp
        ? this.props.updateDataProp.specilization
        : "",
      name: this.props.updateDataProp ? this.props.updateDataProp.certName : "",
      location: this.props.updateDataProp
        ? this.props.updateDataProp.cerAuthurity
        : "",
      startDate: this.props.updateDataProp
        ? DateFns.format(this.props.updateDataProp.startDate, "YYYY-MM-DD")
        : "",
      endDate: this.props.updateDataProp
        ? DateFns.format(this.props.updateDataProp.endDate, "YYYY-MM-DD")
        : "",
      grade: this.props.updateDataProp ? this.props.updateDataProp.grade : "",

      certificate: this.props.updateDataProp
        ? this.props.updateDataProp.certificateNo
        : "",
      percentage: this.props.updateDataProp
        ? this.props.updateDataProp.percentage
        : "",
      todateback: "",
      fromdateback: "",
      errorYear: "",
      toErrorYear: "",
      buttonAction:false,

      id: this.props.updateDataProp ? this.props.updateDataProp.id : undefined,
      message: "",
      error: "",
      dateError: "",
      getGrade:[]
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.dateOnChange = this.dateOnChange.bind(this);
    this.onPercentChange = this.onPercentChange.bind(this);
  
  }


  // common onchange function
  onChange(e) {
    Validator(e.target);
    this.setState({
      [e.target.name]: e.target.value,
      buttonAction:false,
    });
    console.log(e.target.value);
  }



   // submit function by clicking submit button

  onSubmit(e) {
    e.preventDefault();
    submitValidator(e.target);

 
    let dateFrom =  DateFns.format(this.state.startDate, "YYYY-MM-DD")
    let dateTo = DateFns.format(this.state.endDate, "YYYY-MM-DD")
 

    let data = {
      canInfoId:this.props.profile.data.id,
      certName: this.state.name,
      specilization: this.state.specilization,
      percentage: this.state.percentage,
      cerAuthurity: this.state.location,
      certificateNo: Number(this.state.certificate),
      startDate: dateFrom,
      endDate: dateTo,

      grade: this.state.grade,
    };
 
   this.setState({
     buttonAction:true
   })
    if (
      valid &&
      !this.state.dateError &&
      !this.statetoErrorYear &&
      !this.state.errorYear
    ) {
      axios
        .post(`${API_CANDIDATE}/v1/api/can-certification`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "successfully created",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }
 // update function by clicking update button
  onUpdate(e) {
 
    e.preventDefault();
    submitValidator(e.target);

    let dateFrom =  DateFns.format(this.state.startDate, "YYYY-MM-DD")
    let dateTo = DateFns.format(this.state.endDate, "YYYY-MM-DD")

    let data = {
      canInfoId:this.props.profile.data.id,
      id: this.state.id,
      certName: this.state.name,
      specilization: this.state.specilization,
      percentage: this.state.percentage,
      cerAuthurity: this.state.location,
      certificateNo: Number(this.state.certificate),
      startDate: dateFrom,
      endDate: dateTo,

      grade: this.state.grade,
    };
    this.setState({
      buttonAction:true
    })
    if (
      valid &&
      !this.state.dateError &&
      !this.statetoErrorYear &&
      !this.state.errorYear
    ) {
      axios
        .put(`${API_CANDIDATE}/v1/api/can-certification`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "Updated successfully ",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }


  // percentage onchange function

  onPercentChange(e) {
  this.setState({
    buttonAction:false
  })

    console.log(e.target.value);
    var x = e.target.value;
   
      
    if(x.match(/^\d{0,3}\.\d{0,2}$/) || x.match('^[0-9]+$')){
      this.setState({
        percentage: e.target.value,
        isPercentError: "",
      });
}
   else {
    this.setState({
      isPercentError: "percentage not valid",
    });
 }

}

// date onchange validation

  dateOnChange(e) {
    this.setState({
    buttonAction:false  
    })
    if (e.target.name === "startDate") {
      this.setState({
        toDate: "",
        
      });
      errors.startDate = "";
      let date = new Date(e.target.value);
      let dateYear = date.getFullYear();

      if (
        dateYear.toString().length < 4 ||
        dateYear.toString().length > 4 ||
        dateYear > new Date(Date.now()).getFullYear()
      ) {
        this.setState({
          errorYear: "please enter valid date",
        });
      } else {
        this.setState({
          errorYear: "",
        });
      }
    }
    if (e.target.name === "endDate") {
      let dateTo = new Date(e.target.value);
      let dateYearTo = dateTo.getFullYear();

      if (
        dateYearTo.toString().length < 4 ||
        dateYearTo.toString().length > 4 ||
        dateYearTo > new Date(Date.now()).getFullYear()
      ) {
        this.setState({
          toErrorYear: "please enter valid date",
          dateError: "",
        });
      } else {
        this.setState({
          toErrorYear: "",
        });
      }
      if (
        Date.parse(e.target.value) < Date.parse(this.state.startDate) ||
        !this.state.endDate
      ) {
        this.setState({
          [e.target.name]: e.target.value,
          dateError: "EndDate must be greater than or equal to StartDate",
          toErrorYear: "",
        });
        errors.endDate = "";
      } else {
        this.setState({
          [e.target.name]: e.target.value,
          dateError: "",
        });
        errors.endDate = "";
      }
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
      errors.startDate = "";
    }
  }

 

  componentDidMount() {
    this.props.getProfileInfo();
    this.getGradeData();
    refresh();
    this.setState({
      message: "",
      error: "",
    });
  }

  // get dynamic grade from rs

  getGradeData() {
    axios
      .get(`${RS_API}/v1/api/can-qualification-grade/can`, { withCredentials: true })
      .then((res) => {
        console.log(res);
        this.setState({
          getGrade: res.data,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  render() {
    const {
      specilization,
      name,
      location,
      percentage,
      startDate,
      certificate,
      endDate,

      grade,
      message,
      error,
    } = this.state;

    return (
      <>
         {/* applied ternary operator for checking whether it is update or submit form */}
        {!this.props.updateDataProp ? (
          <div style={{ paddingLeft: "2.5rem" }}>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span> Trainings & Certifications</span>
              </div>
              <div>
                <Form onSubmit={this.onSubmit} className="p-3" noValidate>
                  <Row>
                    <Col md="6">
                      <FormComponent
                        index="1"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Certificate Name"
                        type="textarea"
                        minlength="2"
                        maxlength="60"
                        name="name"
                        inputClass="form-control-sm"
                        value={name}
                        change={this.onChange}
                        required={true}
                      />
                      <FormComponent
                        index="3"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Specialization"
                        minlength="2"
                        maxlength="60"
                        type="textarea"
                        name="specilization"
                        inputClass="form-control-sm"
                        value={specilization}
                        change={this.onChange}
                        required={true}
                      />
                      <FormComponent
                        index="5"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Certificate Authority"
                        type="textarea"
                        minlength="2"
                        maxlength="60"
                        name="location"
                        inputClass="form-control-sm"
                        value={location}
                        change={this.onChange}
                        required={true}
                      />
                      <FormComponent
                        index="7"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Percentage"
                        type="number"
                        name="percentage"
                        inputClass="form-control-sm"
                        value={percentage}
                        change={this.onChange}
                        required={true}
                      />
                    </Col>
                    <Col md="6">
                      <FormComponent
                        index="2"
                        max={new Date()}
                        // max={moment().format("YYYY-MM-DD")}
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Start Date"
                        type="date"
                        name="startDate"
                        inputClass="form-control-sm"
                        value={startDate}
                        change={this.dateOnChange}
                        required={true}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.errorYear}
                      </span>
                      <FormComponent
                        index="4"
                        max={moment().format("YYYY-MM-DD")}
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="End Date"
                        type="date"
                        name="endDate"
                        inputClass="form-control-sm"
                        value={endDate}
                        change={this.dateOnChange}
                        min={this.state.startDate}
                        required={true}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.dateError}
                      </span>
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.toErrorYear}
                      </span>
                      <FormComponent
                        index="6"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Certificate No. "
                        type="number"
                        minlength="2"
                        maxlength="60"
                        name="certificate"
                        inputClass="form-control-sm"
                        value={certificate}
                        change={this.onChange}
                        required={true}
                      />

                      {/* <FormComponent
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Grade "
                        type="text"
                        name="grade"
                        inputClass="form-control-sm"
                        value={grade}
                        change={this.onChange}
                        required={true}
                      /> */}
                      <FormGroup>
                        <Label className="bold label-sm">Grade</Label>
                        <Input
                          tabIndex="8"
                          style={{ height: "50px", marginTop: "10px" }}
                          type="select"
                          name="grade"
                          className="form-control-sm"
                          value={grade}
                          onChange={this.onChange}
                          // placeholder="Skill Group"
                        
                        >
                          <option value="" hidden>
                            Select...
                          </option>
                          {this.state.getGrade.map((item) => {
                            return (
                              <option key={item.key} value={item.gradeName}>
                                {item.gradeName}
                              </option>
                            );
                          })}
                        </Input>
                        {errors.grade && (
                          <span style={{color:"red"}} className="error">{errors.grade}</span>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <div className="center">
                    <Button
                      tabIndex = "9"
                      disabled={this.state.buttonAction}
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "30px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Submit
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        ) : (
          <div>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span> Training & Certification</span>
              </div>
              <div>
                <Form onSubmit={this.onUpdate} className="p-3" noValidate>
                  <Row>
                    <Col md="6">
                      <FormComponent
                        index="1"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Certificate Name"
                        type="textarea"
                        minlength="2"
                        maxlength="60"
                        name="name"
                        inputClass="form-control-sm"
                        value={name}
                        change={this.onChange}
                        required={true}
                      />
                      <FormComponent
                        index="3"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Specialization"
                        minlength="2"
                        maxlength="60"
                        type="textarea"
                        name="specilization"
                        inputClass="form-control-sm"
                        value={specilization}
                        change={this.onChange}
                        required={true}
                      />
                      <FormComponent
                        index="5"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Certificate Authority"
                        type="textarea"
                        minlength="2"
                        maxlength="60"
                        name="location"
                        inputClass="form-control-sm"
                        value={location}
                        change={this.onChange}
                        required={true}
                      />
                      <FormComponent
                        index="7"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Percentage"
                        type="number"
                        name="percentage"
                        inputClass="form-control-sm"
                        value={percentage}
                        change={this.onChange}
                        required={true}
                      />
                    </Col>
                    <Col md="6">
                      <FormComponent
                        index="2"
                        max={new Date()}
                        // max={moment().format("YYYY-MM-DD")}
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Start Date"
                        type="date"
                        name="startDate"
                        inputClass="form-control-sm"
                        value={startDate}
                        change={this.dateOnChange}
                        required={true}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.errorYear}
                      </span>
                      <FormComponent
                        index="4"
                        max={moment().format("YYYY-MM-DD")}
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="End Date"
                        type="date"
                        name="endDate"
                        inputClass="form-control-sm"
                        value={endDate}
                        change={this.dateOnChange}
                        min={this.state.startDate}
                        required={true}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.dateError}
                      </span>
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.toErrorYear}
                      </span>
                      <FormComponent
                        index="6"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Certificate No. "
                        type="number"
                        minlength="2"
                        maxlength="60"
                        name="certificate"
                        inputClass="form-control-sm"
                        value={certificate}
                        change={this.onChange}
                        required={true}
                      />

                      {/* <FormComponent
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Grade "
                        type="text"
                        name="grade"
                        inputClass="form-control-sm"
                        value={grade}
                        change={this.onChange}
                        required={true}
                      /> */}
                      <FormGroup>
                        <Label className="bold label-sm">Grade</Label>
                        <Input
                          tabIndex="8"
                          style={{ height: "50px", marginTop: "10px" }}
                          type="select"
                          name="grade"
                          className="form-control-sm"
                          value={grade}
                          onChange={this.onChange}
                          // placeholder="Skill Group"
                        
                        >
                          <option value="" hidden>
                            Select...
                          </option>
                          {this.state.getGrade.map((item) => {
                            return (
                              <option key={item.key} value={item.gradeName}>
                                {item.gradeName}
                              </option>
                            );
                          })}
                        </Input>
                        {errors.grade && (
                          <span style={{color:"red"}} className="error">{errors.grade}</span>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <div className="center">
                    <Button
                      tabIndex="9"
                      disabled={this.state.buttonAction}
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "30px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Update
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}




const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps,{getProfileInfo})(
  withRouter(UpdateCertificateDetails)
);

